import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { fetchProducts, ShopifyProduct } from "@/lib/shopify";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/shop/ProductCard";
import { toast } from "sonner";

const Sweatshirts = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState<ShopifyProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const allProducts = await fetchProducts(50);
      const sweatshirts = allProducts.filter(p => 
        p.node.title.toLowerCase().includes('sweatshirt') ||
        p.node.title.toLowerCase().includes('hoodie')
      );
      setProducts(sweatshirts);
    } catch (error) {
      console.error('Error loading products:', error);
      toast.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/20 flex flex-col">
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Button variant="ghost" onClick={() => navigate('/shop')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Shop
          </Button>
          <h1 className="text-2xl font-bold">Sweatshirts</h1>
          <CartDrawer />
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 flex-1">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Cozy Sweatshirts</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Ultimate comfort meets empowering messages
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : products.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-muted-foreground">No sweatshirts available yet</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {products.map((product) => (
              <ProductCard key={product.node.id} product={product} />
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Sweatshirts;
